import { useNamespaceContainer } from "@pharaday/namespace";

import { OrganizationProfileRepository } from "../core/application/store/organization-profile.repository";

const useOrganizationProfileApi = () => {
  const container = useNamespaceContainer();

  return {
    api: {
      organizationProfile: container.get<OrganizationProfileRepository>(OrganizationProfileRepository),
    },
  };
};

export { useOrganizationProfileApi };
